import { EditOutlined, FileAddOutlined } from '@ant-design/icons'
import { MemberProps } from 'app/components/Core/convention'
import Form from 'app/components/Core/DamageInfo/Form'
import Upload from 'app/components/Core/Document/Upload'
import KButton from 'app/components/Modules/General/KButton'
import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'

const FINAL_STAGES: IDamageInfoStage[] = ['finalized']

const Action: React.FC<MemberProps<IDamageInfo>> = ({ member }) => {
  const {
    modalify: { open, close },
    drawerfy
  } = useFeedbacker()
  const props: IDocument = {
    model_id: member.rental_id,
    line_item_id: member.line_item_id,
    document_type: 'damages',
    model_type: 'Rental'
  }
  const isFinalStage = FINAL_STAGES.includes(member.damage_stage)

  const onEdit = () =>
    open({
      recordType: RecordType.damage_info,
      action: 'update',
      modalType: 'form',
      content: <Form member={member} props={{ onSuccess: close }} />
    })
  const onDocuments = () =>
    drawerfy.open({
      recordType: RecordType.document,
      action: 'create',
      width: 500,
      content: <Upload args={{ filters: { damage_info_id: [member.id] } }} props={props} />
    })

  return (
    <>
      <KButton
        onClick={onDocuments}
        icon={<FileAddOutlined />}
        type="secondary"
        className="mr-1"
        recordType={RecordType.damage_info}
        action="document"
      />
      {!isFinalStage && (
        <KButton
          onClick={onEdit}
          icon={<EditOutlined />}
          type="primary"
          disabled={isFinalStage}
          recordType={RecordType.damage_info}
          action="update"
        />
      )}
    </>
  )
}

export default Action
